import { PageInfo } from '../../../shared/models/queryparams/pageinfo.model';
import { SortInfo } from '../../../shared/models/queryparams/sortinfo.model';

export class ReportDataViewRequest {
  constructor(
    public dataViewId: number,
    public locations: any[],
    public startDate: Date,
    public endDate: Date,
    public pageInfo: PageInfo,
    public sortInfo: SortInfo,
    public allLocations?: boolean
  ) {}
}
